var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute inset-0 z-10 bg-slate-50/60"},[_c('div',{staticClass:"flex h-full w-full items-center justify-center"},[_c('div',{staticClass:"flex size-10 items-center justify-center rounded-full bg-white shadow-sm ring-1 ring-slate-200"},[_c('Icon',{staticClass:"size-5 text-slate-700",attrs:{"icon":_vm.IconEnums.LOCK}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }